import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { initGA4, initMetaPixel } from "@/lib/tracking";

const TrackingContext = createContext({ metaPixelId: "", ga4MeasurementId: "" });

export function TrackingProvider({ children }) {
  const [ids, setIds] = useState({ metaPixelId: "", ga4MeasurementId: "" });

  useEffect(() => {
    let cancelled = false;
    api
      .get("/settings/tracking")
      .then((r) => {
        if (cancelled) return;
        const next = {
          metaPixelId: r.data?.meta_pixel_id || "",
          ga4MeasurementId: r.data?.ga4_measurement_id || "",
        };
        setIds(next);
        if (next.metaPixelId) initMetaPixel(next.metaPixelId);
        if (next.ga4MeasurementId) initGA4(next.ga4MeasurementId);
      })
      .catch(() => {
        /* silent — tracking is optional */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return <TrackingContext.Provider value={ids}>{children}</TrackingContext.Provider>;
}

export function useTracking() {
  return useContext(TrackingContext);
}
